const CTYPE = Object.freeze({
  json: 'json',
  text: 'text',
});

// noinspection JSUnusedGlobalSymbols
export default CTYPE;
